import React from 'react';
import PropTypes from 'prop-types';
import {EmptyState} from '@shopify/polaris';
import {notifyException} from '../../../../../utilities/analytics/bugsnag';

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {error: null};
  }

  componentDidCatch(error, errorInfo) {
    this.setState({error});
    notifyException({
      errorName: 'ServicesMarketplace::ErrorBoundary',
      error,
      meta: {errorInfo},
    });
  }

  render() {
    if (this.state.error) {
      return (
        <EmptyState
          heading="Something went wrong"
          action={{content: 'Try again', onClick: () => location.reload()}}
          secondaryAction={{}}
          image="https://cdn.shopify.com/s/files/1/0757/9955/files/empty-state.svg"
        >
          <p>
            We&#39;ve encountered an unexpected technical issue. Please check
            back in a few minutes &ndash; we&#39;ll be up and running in no
            time!
          </p>
        </EmptyState>
      );
    }

    return this.props.children;
  }
}

ErrorBoundary.propTypes = {
  children: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
};
